/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { HAS_NEUTRAUBLING_SENSOR_DATA } from '@/config/csvSensors';
import { MUENSTER_DEVICE_SENSOR_CONFIG, NEUTRAUBLING_DEVICE_SENSOR_CONFIG } from '@/config/deviceSensorConfig';
import { DeviceSensorCatalog } from '@/lib/sensors/catalog/deviceSensorCatalog';
import type { ConfigurationTags } from '@/types/eeCheck';
import type { DeviceSensorSystemGroup } from '@/types/deviceSensor';

export type ConfigurationCustomer = ConfigurationTags['customer'];

const CONFIGURATION_GROUPS: Exclude<DeviceSensorSystemGroup, 'DTC'>[] = ['BL', 'HE', 'PV'];

export function getConfigurationCustomers(): ConfigurationCustomer[] {
    return HAS_NEUTRAUBLING_SENSOR_DATA ? ['neutraubling', 'muenster'] : ['muenster'];
}

export function getConfigurationSystems(customer: ConfigurationCustomer): string[] {
    const catalog = new DeviceSensorCatalog(
        customer === 'muenster'
            ? MUENSTER_DEVICE_SENSOR_CONFIG
            : NEUTRAUBLING_DEVICE_SENSOR_CONFIG,
    );

    return Array.from(new Set(
        catalog.getVirtualDevices().flatMap((deviceName) => (
            CONFIGURATION_GROUPS.map((group) => (
                catalog.getSensorMetadata(deviceName, group)?.system ?? null
            ))
        )).filter((system): system is string => system !== null),
    )).sort((left, right) => left.localeCompare(right));
}
